import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { useLoading } from "../../../context/LoadingContext";
import { useAlert } from "../../../context/AlertContext";
import { useAuth } from "../../../context/AuthContext";
import {
  deleteServiceRequest,
  getServiceRequest
} from "../../../commons/ServiceRequest";
import { autoDisplayValue, formatCurrency } from "../../../commons/FormatValue";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import {
  filteredItemInArray,
  findItemInArray
} from "../../../utils/ManageArray";
import {
  FloatingControlComponent,
  SearchSelectComponent
} from "../../FormComponent";
import TableForm from "../../TableForm";
import ConfirmModal from "../../ConfirmModal";
import CardDisplayComponent from "../../CardDisplayComponent";
import ChildBomsService from "../../../services/childboms.service";
import InformInstallItemsService from "../../../services/informinstallitem.service";
import InformInstallItemBomsService from "../../../services/informinstallitembom.service";
import ItemsService from "../../../services/item.service";
import InformInstallJobsService from "../../../services/informinstalljob.service";

const CreateInstallationBomForm = ({ editData, onSubmitCallbackBom }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  const { loading, setLoading } = useLoading(false);
  const [showModal, setShowModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [Items, setItems] = useState([]);
  const [ParentSearch, setParentSearch] = useState([]);
  const [InstallItem, setInstallItem] = useState([]);
  const [ChildBoms, setChildBoms] = useState([]);

  const defaultData = {
    Item_child: {
      Com_Code: user.Com_Code,
      Install_Item_Id: null,
      Item_Child_Id: null,
      Item_Qty: null,
      Uom_Unit: null,
      Price_Per_Unit: null,
      Amount: null,
      Amount_Unit: null
    }
  };

  const [data, setData] = useState({
    Item_child: { Array: [defaultData.Item_child] }
  });

  const inputField = {
    Item_child: [
      {
        name: "Item_Child_Id",
        label: "รหัสอุปกรณ์",
        type: "select",
        size: 2,
        filterBy: ["Item_Code"],
        options: initializeSetOption({
          key: "Id",
          label: "Item_Code",
          dataset: Items
        }),
        queryService: (query) =>
          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest: ItemsService.getAllItems(query),
            callback: ({ items }) => setItems(items)
          })
      },
      {
        name: "Item_Name_TH",
        label: "รายละเอียดอุปกรณ์/อะไหล่",
        classNames: { col: "mb-3", label: "mb-1" },
        type: "text",
        size: 2,
        findValue: { data: Items, key: "Id", value: "Item_Child_Id" },
        readOnly: true,
        noneRequired: true
      },
      {
        name: "Item_Model",
        label: "Model Number",
        findValue: { data: Items, key: "Id", value: "Item_Child_Id" },
        type: "text",
        readOnly: true,
        noneRequired: true
      },
      {
        name: "Item_Qty",
        label: "จำนวน",
        type: "text",
        format: (row) => formatCurrency(row.Item_Qty || "")
      },
      {
        name: "Uom_Unit",
        label: "หน่วย",
        findValue: { data: Items, key: "Id", value: "Item_Child_Id" },
        type: "text",
        readOnly: true,
        noneRequired: true
      },
      {
        name: "Price_Per_Unit",
        label: "ราคา",
        type: "text",
        format: (row) => formatCurrency(row.Price_Per_Unit || "")
      },
      {
        name: "Amount",
        label: "ราคารวม",
        type: "text",
        format: (row) => formatCurrency(row.Amount || ""),
        readOnly: true,
        noneRequired: true,
        sumValue: {
          firstName: "Item_Qty",
          secondName: "Price_Per_Unit",
          operator: "*"
        }
      },
      {
        name: "Amount_Unit",
        label: "สกุลเงิน",
        type: "text"
      }
    ]
  };

  const handleDeleteTableForm = (data, newData, type) => {
    const findDelId = data.find(
      ({ Id }) => !newData.some((item) => Id === item.Id)
    )?.Id;
    if (editData && findDelId) {
      if (type === "Item_child") {
        handleDeleteSubmit(
          InformInstallItemBomsService.deleteInformInstallItemBoms(
            findDelId,
            true
          )
        );
      }
    }
  };

  const handleDeleteSubmit = (service) => {
    deleteServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: service
    });
  };

  const handleValidated = (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (!form.checkValidity()) {
      event.stopPropagation();
      setValidated(true);
    } else {
      setShowModal(true);
    }
  };

  const handleSubmitฺBom = (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);
    if (dataCallback) {
      onSubmitCallbackBom(dataCallback);
    }
  };

  useEffect(() => {
    console.log(state);
    if (state.name === "edit") {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: InformInstallJobsService.getAllInformInstallJobs(),
        callback: (res) => {
          const dataInstallItem = filteredItemInArray(
            res,
            "Id",
            state.searchValue
          );

          const dataInstallItemParen = dataInstallItem.map(
            (item) => item.InformInstallItem
          );
          const extractedItemIds = dataInstallItemParen
            .flat()
            .map((itemBom) => itemBom.InformInstallItemBom);
          const nonEmptyArrays = extractedItemIds.filter(
            (arr) => arr.length > 0
          );
          setInstallItem(dataInstallItemParen[0]);
          setParentSearch(nonEmptyArrays[0][0].Install_Item_Id);

          getServiceRequest({
            showAlert,
            setLoading,
            serviceRequest:
              InformInstallItemBomsService.getAllInformInstallItemBoms(),
            callback: (resBom) => {
              setItems(
                filteredItemInArray(
                  resBom,
                  "Install_Item_Id",
                  nonEmptyArrays[0][0].Install_Item_Id
                ).map((item) => item.ItemChild)
              );

              setData((prev) => ({
                ...prev,
                Item_child: {
                  Array: filteredItemInArray(
                    resBom,
                    "Install_Item_Id",
                    nonEmptyArrays[0][0].Install_Item_Id
                  )
                } // กำหนดค่าใหม่ให้กับ Item_child
              }));
            }
          });

          // setInstallItem(dataInstallItemParen[0]);
          // console.log(dataInstallItemParen);
          // setParentSearch(nonEmptyArrays[0][0].Install_Item_Id);

          // setData((prev) => ({
          //   ...prev,
          //   Item_child: { Array: nonEmptyArrays[0] } // กำหนดค่าใหม่ให้กับ Item_child
          // }));
        }
      });
      // getServiceRequest({
      //   showAlert,
      //   setLoading,
      //   serviceRequest:
      //     InformInstallItemBomsService.getAllInformInstallItemBoms(),
      //   callback: (res) => {
      //     const dataItemBom = filteredItemInArray(
      //       res,
      //       "InformInstallItem.Job_Install_Id",
      //       state?.searchValue
      //     );
      // console.log(InstallItem.InformInstallItemBom)
      // setParentSearch(dataItemBom[0]?.InformInstallItem?.Item_Id);
      // setItems(dataItemBom?.map((item) => ({ ...item.ItemChild })));
      // setData((prev) => ({
      //   ...prev,
      //   Item_child: {
      //     Array: dataItemBom?.map((item) => {
      //       return {
      //         Id: item?.Id,
      //         Install_Item_Id: item?.Install_Item_Id,
      //         Item_Child_Id: item?.Item_Child_Id,
      //         Item_Qty: item?.Item_Qty,
      //         Price_Per_Unit: item?.Price_Per_Unit,
      //         Amount: item?.Amount,
      //         Amount_Unit: item?.Amount_Unit,
      //         Uom_Unit: item?.ItemChild?.Unit,
      //         Com_Code: item?.ItemChild?.Com_Code
      //       };
      //     })
      //   }
      // }));
    } else {
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: InformInstallItemsService.getAllInformInstallItems(),
        callback: (res) => {
          const dataItemParent = filteredItemInArray(
            res,
            "Job_Install_Id",
            state?.searchValue
          );
          setInstallItem(dataItemParent);
        }
      });
      getServiceRequest({
        showAlert,
        setLoading,
        serviceRequest: ChildBomsService.getAllChildBoms(),
        callback: (res) => setChildBoms(res)
      });
    }
    // });
    // }
  }, []);

  return (
    <>
      <CardDisplayComponent
        header={{
          title: {
            text: "เพิ่มรายการอุปกรณ์/อะไหล่",
            className: "text-center"
          }
        }}
        body={{
          element: (
            <Row className="justify-content-center">
              <Col sm={3}>
                <SearchSelectComponent
                  floatingClass="mb-1"
                  labelField="รหัสสินค้า"
                  placeholder="โปรดเลือก"
                  filterBy={["Item.Item_Code"]}
                  options={initializeSetOption({
                    key: "Item_Id",
                    label: "Item.Item_Code",
                    dataset: InstallItem
                  })}
                  onChange={(selected) => {
                    if (state.name === "create") {
                      const itemsOnly = filteredItemInArray(
                        ChildBoms,
                        "ParentBom.Item_Parent_Id",
                        selected?.value
                      ).map((item) => item.Item);

                      const items_Id = filteredItemInArray(
                        InstallItem,
                        "Item_Id",
                        selected?.value
                      )?.[0]?.Id;

                      setData((prev) => ({
                        ...prev,
                        Item_child: {
                          Array: itemsOnly?.map((item) => {
                            return {
                              ...defaultData?.Item_child?.Array,
                              Install_Item_Id: items_Id,
                              Item_Child_Id: item?.Id,
                              Item_Name_TH: item?.Item_Name_TH,
                              Uom_Unit: item?.Unit,
                              Com_Code: item?.Com_Code
                            };
                          })
                        }
                      }));
                      setItems(itemsOnly);
                      setParentSearch(selected?.value);
                    }
                  }}
                  value={`${ParentSearch}`}
                />
              </Col>
              <Col sm={6}>
                <FloatingControlComponent
                  type="text"
                  name="Item.Item_Name_TH"
                  label="รายละเอียดสินค้า"
                  readOnly
                  value={autoDisplayValue({
                    name: "Item.Item_Name_TH",
                    type: "text",
                    findValue: {
                      data: InstallItem,
                      key: "Item_Id",
                      value: ParentSearch
                    }
                  })}
                />
              </Col>
            </Row>
          )
        }}
      />
      <Form noValidate validated={validated} onSubmit={handleValidated}>
        <CardDisplayComponent
          body={{
            element: (
              <TableForm
                data={data?.Item_child?.Array}
                columns={inputField?.Item_child}
                defaultData={defaultData?.Item_child}
                duplicateKey={["Item_Child_Id"]}
                onChangeCallback={(newData) => {
                  handleDeleteTableForm(
                    data?.Item_child?.Array,
                    newData,
                    "Item_child"
                  );
                  setData((prev) => ({
                    ...prev,
                    Item_child: {
                      Array: newData.map((item) => {
                        return {
                          ...item,
                          Install_Item_Id:
                            data?.Item_child?.Array?.[0]?.Install_Item_Id,
                          Item_Child_Id: Number(item?.Item_Child_Id),
                          Amount:
                            Number(item?.Item_Qty) *
                            Number(item?.Price_Per_Unit),
                          Uom_Unit:
                            item?.Uom_Unit ||
                            findItemInArray(Items, "Id", item?.Item_Child_Id)
                              ?.Unit ||
                            ""
                        };
                      })
                    }
                  }));
                }}
              />
            )
          }}
          footer={{
            className: "text-end",
            element: (
              <>
                <Button
                  type="submit"
                  variant="success"
                  className="me-2 px-5 py-2 text-dark rounded-pill"
                >
                  {state?.name === "edit" ? "แก้ไขข้อมูล" : "บันทึกข้อมูล"}
                </Button>

                <ConfirmModal
                  show={showModal}
                  data={data}
                  content={editData ? "edit" : "save"}
                  onSubmitCallback={handleSubmitฺBom}
                />
                {editData && (
                  <Button
                    type="button"
                    variant="success"
                    className="me-2 px-5 py-2 text-dark rounded-pill"
                    onClick={() =>
                      navigate("/installation_work/record", {
                        state: {
                          name: "edit",
                          searchValue: `${state.searchValue}`
                        }
                      })
                    }
                  >
                    ย้อนกลับ
                  </Button>
                )}
              </>
            )
          }}
        />
      </Form>
    </>
  );
};
CreateInstallationBomForm.propTypes = {
  editData: PropTypes.object,
  onSubmitCallbackBom: PropTypes.func
};

export default CreateInstallationBomForm;
